<template>
  <variants>
    <template #narrow>
      <div class="p-fl-lg bg-pp1 rounded-md">
        <div class="text-fl-2xl text-black font-semibold mb-fl-sm">
          Want to learn bass 3-5x faster? Grab one of our FREE mini-courses!
        </div>
        <div class="text-fl-xl text-black mb-fl-lg">
          From soloing & technique, to fretboard & theory, these mini-courses cover the most
          essential topics all bass players need to know. <strong>Get instant access now!</strong>
        </div>
        <standard-button
          :url="'https://lp.scottsbasslessons.com/free-stuff'"
          :label="'Grab a FREE mini course →'"
          :color="'black-on-transparent'"
          :expand="true"
        />
      </div>
    </template>
    <template #sm+>
      <div class="flex gap-4 p-fl-xl bg-pp1 rounded-xl">
        <div class="basis-1/2">
          <div class="text-fl-3xl text-black font-semibold mb-fl-md">
            Want to learn bass 3-5x faster? Grab one of our FREE mini-courses!
          </div>
          <div class="text-fl-xl text-black mb-fl-xl">
            From soloing & technique, to fretboard & theory, these mini-courses cover the most
            essential topics all bass players need to know. <strong>Get instant access now!</strong>
          </div>
          <standard-button
            :url="'https://lp.scottsbasslessons.com/free-stuff'"
            :label="'Grab a FREE mini course →'"
            :color="'black-on-transparent'"
          />
        </div>
        <div class="basis-1/2 flex-wrap">
          <imgix-image :config="imageConfig" class="w-full object-cover" />
        </div>
      </div>
    </template>
  </variants>
</template>

<script lang="ts">
import {defineComponent} from 'vue';
import Variants from '../../../core/column-layout/Variants.vue';
import StandardButton from '../../../core/button/StandardButton.vue';
import ImgixImage from '../../../core/imgix-image/ImgixImage.vue';
import {ImgixImageConfig} from '../../../core/imgix-image/types';

export default defineComponent({
  components: {
    Variants,
    StandardButton,
    ImgixImage
  },
  setup() {
    const imageConfig: Readonly<ImgixImageConfig> = {
      path: 'content/freestuff-promo.png',
      alt: 'Free Stuff Promo Image',
      width: 620
    };

    return {
      imageConfig
    };
  }
});
</script>
